import * as React from "react";
import {DocumentManager} from "../Manager/PDFManager/DocumentManager";

export class PDFFieldLayer extends React.Component<PDFFieldLayerProps, PDFFieldLayerState> {
    static defaultProps: Partial<PDFFieldLayerProps> = {};

    constructor(props: PDFFieldLayerProps) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.DocumentManager.SelectedPDFFieldChanged.Subscribe(this,()=>this.forceUpdate());
    }

    componentWillUnmount() {
        this.props.DocumentManager.SelectedPDFFieldChanged.Unsubscribe(this);
    }

    public render() {
        return (
            <div className={'pdfHighlightLayer'} style={{position:'absolute',top:0,left:0,height:'100%'}}>
                {
                    this.props.DocumentManager.PDFFields.map(field=>{
                        if(field.Page==this.props.DocumentManager.SelectedPage)
                            return field.RenderRect();

                        return null;
                    })
                }
            </div>
        )
    }

}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface PDFFieldLayerProps {
    DocumentManager:DocumentManager;
}

interface PDFFieldLayerState {

}

//#endregion "My Region"